"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpSeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25 21v1h-2a71.07 71.07 0 00-2-17.27L20.75 4H17V1h-2v3h-3.75l-.25.73A71.07 71.07 0 009 22H7v-1H5v10h2v-1h18v1h2V21zM12.78 6h6.44A74.74 74.74 0 0121 22H11a74.74 74.74 0 011.78-16zM7 28v-4h18v4z" })));
}
exports.default = SvgPumpSeOutline;
//# sourceMappingURL=PumpSeOutline.js.map